<template>
  <div class="toast-container top-0 end-0 p-3 h-100 overflow-hidden">
    <!-- Then put toasts within -->
    <div
      v-for="toast in toasterStore.toasts"
      :key="toast.id"
      class="toast show"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style="max-width: 350px; margin-left: auto"
    >
      <div class="toast-header" :class="(toast.text_type ? `text-${toast.text_type}` : '') + ' ' + (toast.bg_type ? `bg-${toast.bg_type}` : '') ">
        <i v-if="toast.icon" :class="`fa fa-fw ${toast.icon} me-1`" />
        <strong class="me-auto">{{ toast.title }}</strong>
        <!--<small class="text-body-secondary">just now</small>-->
        <button type="button" class="btn btn-sm p-0" :class="toast.text_type ? `text-${toast.text_type}` : '' " data-bs-dismiss="toast" aria-label="Close">
          <i class="fa fa-fw fa-xmark" />
        </button>
      </div>
      <div v-if="toast.message" class="toast-body">{{ toast.message }}</div>
    </div>

  </div>
</template>

<script setup lang="ts">
import useToasterStore from './toasts';
const toasterStore = useToasterStore();

// Todo: Add animations like
// https://mdbootstrap.com/docs/standard/content-styles/animations/
</script>

<style lang="scss">
@import '../../sass/base';

.toast-header:not(:has(+ .toast-body)) {
    border-bottom-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
    border-bottom-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
</style>